/**
 * Configure the plugin.
 */

+function($){
  page.registerVendor('Isotope');

  page.initIsotope = function() {
    if ( undefined === window['Isotope'] || 0 === $('.isotope-main-box').length ) {
      return;
    }

      $(".isotope-main-box").each(function () {
          let mainContainer = $(this),
              $isotope = mainContainer.find(".isotope-list").isotope({
                  percentPosition: true
              });

          mainContainer.imagesLoaded(function () {
              $isotope.isotope("layout");
              mainContainer.find(".isotope-filter").on("click", "a", function (e) {
                  e.preventDefault();
                  $(this).parent().siblings().find("a").removeClass("active");
                  $(this).addClass("active");
                  let filterValue = $(this).attr("data-filter");
                  $isotope.isotope({
                      filter: filterValue
                  });
              });
          });
      });
  }

}(jQuery);



